import { DocumentNode, gql } from '@apollo/client';
import { Button, Heading, Stack } from '@chakra-ui/react';
import * as React from 'react';

import { Attribute } from '@/components/Attribute';
import { Card } from '@/imports/ui/chakra/components/Card';
import { ATTRIBUTE_FRAGMENT } from '@/modules/attributes';

import { OrganizationPageInformation_OrganizationFragment } from './graphql-types/OrganizationPageInformation_OrganizationFragment';

const ORGANIZATION_FRAGMENT = gql`
  fragment OrganizationPageInformation_OrganizationFragment on Organization {
    _id
    profileAttributes(input: {}) {
      results {
        attribute {
          ...AttributeFragment
        }
      }
    }
    currentUserOrganizationPermission {
      canManageOrganizationProfile
    }
  }
  ${ATTRIBUTE_FRAGMENT}
`;

export const InfoCard: React.FC<{
  organization: OrganizationPageInformation_OrganizationFragment;
}> & { organizationFragment: DocumentNode } = ({ organization }) => {
  const profileAttributes = organization.profileAttributes.results.filter(
    ({ attribute }) =>
      (attribute.__typename === 'FreeTextAttribute' &&
        attribute.freeTextValue) ||
      (attribute.__typename === 'MultiSelectAttribute' &&
        attribute.multiSelectValue.length) ||
      (attribute.__typename === 'SingleSelectAttribute' &&
        attribute.singleSelectValue)
  );

  const [isAbbreviated, setIsAbbreviated] = React.useState(
    profileAttributes.length > 3
  );

  return (
    <Card as={Stack} spacing="4" p="6">
      <Heading size="md">Info</Heading>

      <Stack spacing="6">
        {profileAttributes
          .slice(0, isAbbreviated ? 3 : undefined)
          .map(({ attribute }) => {
            return (
              <Attribute
                key={attribute._id}
                attribute={attribute}
                isViewingOwnProfile={
                  organization.currentUserOrganizationPermission
                    .canManageOrganizationProfile
                }
              />
            );
          })}

        {isAbbreviated && (
          <Button
            variant="outline"
            colorScheme="gray"
            size="sm"
            onClick={() => setIsAbbreviated(false)}
          >
            View More
          </Button>
        )}
      </Stack>
    </Card>
  );
};

InfoCard.organizationFragment = ORGANIZATION_FRAGMENT;
